import React from 'react'

export default function Footer() {
  return (
    <div className='justify-center text-center w-full text-lg p-5'>© Pepsi.pics - X_Shadow_ 2022 - All rights reserved</div>
  )
}
